import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import PageEditSession from "models/interfaces/page-edit-session";

const defaultValues: PageEditSession =
    RecordUtils.auditableDefaultValuesFactory<PageEditSession>({
        blockId: undefined,
        pageId: 0,
        userId: 0,
        expiresOnUtc: undefined,
        user: undefined,
    });
export default class PageEditSessionRecord
    extends Record(defaultValues)
    implements PageEditSession
{
    constructor(params?: Partial<PageEditSession>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    public with(values: Partial<PageEditSession>): PageEditSessionRecord {
        return new PageEditSessionRecord(Object.assign(this.toJS(), values));
    }
}
